import React, { useEffect, useState, useRef, useMemo } from "react";
import { capitalizeFirstLetter, intersectRect, hit, getBoundsColour } from "./../../../../utils/common"
import './index.scss';
import { tagPanelAction } from "../../../../context/actions/tagPanelAction";
import { maxConfidence } from '../../../../utils/constants';
import { useDispatch, useSelector } from "react-redux";
import { set_is_right_clicked } from "../../../../context/actions/document";
import { debounce } from 'lodash';

const OcrView = ({ prevPage, nextPage, setVersionLoader, pdf, pdfPagesCount, pageNumber, _xmlTags, _xmlTagsOriginal, _activeEditTabs, _uniId, _editTag, _reloadOcr, _editTabsVal, _zoomOcr, scale, _fieldPriority, _setLoader, _priorityFlag, _zoomFlag, activeEditTabsFlag, jsonMetaData, xmlMeta, _version, versionFlag, _setScrollOnSelect, _activeTab, idleScale, unableToValidate }) => {
    // console.log(scale, idleScale, "ocrrrrrrrrr")
    const dispatch = useDispatch();
    const canvasRef = useRef(null);
    const [canvas, setCanvas] = useState(null);
    const [tipCanvas, setTipCanvas] = useState();
    const [tipCtx, setTipCtx] = useState();
    let [canvasContext, setCanvasContext] = useState();
    let [canvasContextFlag, setCanvasContextFlag] = useState(false);
    const [ocrScale, setOcrScale] = useState();
    const [ocrJsonScale, setOcrJsonScale] = useState();
    const [ocrScaleHeight, setOcrScaleHeight] = useState();
    const [ocrJsonScaleHeight, setOcrJsonScaleHeight] = useState();
    const [xmlTags, setXmlTags] = useState([]);
    let [height, setHeight] = useState(null)
    let [canvaProcssing, setCanvaProcssing] = useState(true);
    let xmin = useSelector((state) => state.document?.fileData?.multi_loan_identifier?.xmin);
    let xmax = useSelector((state) => state.document?.fileData?.multi_loan_identifier?.xmax);
    let y = useSelector((state) => state.document?.fileData?.multi_loan_identifier?.y);
    let h = useSelector((state) => state.document?.fileData?.multi_loan_identifier?.h);


    const is_multi_loan = useSelector((state) => state.document?.fileData?.is_multi_loan);


    let fileSetting = useSelector((state) => state?.fileSetting?.data); // get previously filter value
    let isRightClicked = useSelector((state) => state?.document?.isRightClicked);
    const canvaRender = useSelector((state) => state.general.isCanvaRender);
    const fileData = useSelector((state) => state.document.fileData);
    // let confidence = fileSetting.find((item) => {
    //     if (item.title === 'aggregator_logo_confidence') {
    //         return item;
    //     }
    // });
    // let cRedRange = fileSetting.find((item) => {
    //     if (item.title === 'C Red') {
    //         return item;
    //     }
    // });
    // let cYellowRange = fileSetting.find((item) => {
    //     if (item.title === 'C Yellow') {
    //         return item;
    //     }
    // });
    let confidence = fileData?.confidence_range?.aggregator_logo_confidence;
    let cRedRange = fileData?.confidence_range?.c_red
    let cYellowRange = fileData?.confidence_range?.c_yellow
    const onOcrClick = () => {
        dispatch(set_is_right_clicked(false))
    }

    useEffect(() => {
        (async () => {
            // if (pageNumber == 1) {
            // setVersionLoader(false)
            // }
            console.log("dsdsdsdsdad", pdf)
            if (pdf?.img)
                await decodeImg(pdf)
            else
                await decodePdf(pdf);
            await enventRect()
            await drawTagsBounds();
            /** @start restoring canvas distoprtation on page change*/
            setTimeout(() => {
                const e1 = new MouseEvent("click", {
                    clientX: 1673,
                    clientY: 866
                });
                // setVersionLoader(false)
                if (canvas !== null) { // Check if the element with id for canvas exists
                    canvas.dispatchEvent(e1)
                }
            }, 100)

            /** @end */

            setVersionLoader(false)


        })();
    }, [pdf, pageNumber]);

    /*  useEffect(() => {
          (async () => {
              // if (pageNumber == 1) {
              // setVersionLoader(false)
              // }
              // setVersionLoader(true)
              if (pdf?.img)
                  await decodeImg(pdf)
              else
                  await decodePdf(pdf);
              await enventRect()
              await drawTagsBounds();
  
              setVersionLoader(false)
  
          })();
      }, [pdf]) */




    useEffect(() => {
        if (canvasContext && ocrScale)
            eveluateXML()

    }, [canvasContext, ocrScale]);
    // useEffect(() => {
    //     if (canvasContext && ocrScale && xmlTags) {
    //         _xmlTags(prevState => prevState = [...xmlTags]);
    //     }

    // }, []);




    useEffect(() => {
        if (xmlTags && canvas) {
            enventRect()
            drawTagsBounds();
        }




    }, [xmlTags, canvas]);

    const processChange = debounce(() => loadf(), 1000);
    // const debouncedNavigate = debounce((index) => {
    //     // Your navigation code here
    //     loadf()
    // }, 1000);

    /**
    * @description function re initalization on refreash/any actions
    */

    // const loadf = async () => {
    //     // alert("checking loadf function")
    //     console.log(xmlTags, "checking xmlTags length 4444444444444444------>>>>>>>>>>>>>")
    //     if (pdf?.img)
    //         await decodeImg(pdf);
    //     else
    //         await decodePdf(pdf);
    //     await drawTagsBounds()
    //     enventRect()

    // }
    // const debouncedChangeHandler = useMemo(
    //     (xmlTags) => debounce((xmlTags) => {
    //         console.log(xmlTags, "checking xmlTags length 33333333333333------>>>>>>>>>>>>>")

    //         // Your navigation code here
    //         // alert("hii alert")
    //         loadf()
    //     }, 1000)
    //     , [xmlTags]);

    useEffect(() => {
        if (canvas) {
            enventRect()
        }
    }, [isRightClicked])

    useEffect(() => {
        if (_priorityFlag) {
            loadf()
            // processChange()

        }

    }, [_fieldPriority]);

    useEffect(() => {
        if (activeEditTabsFlag) {
            loadf()
            // processChange()
        }
    }, [_activeEditTabs, _editTag]);

    useEffect(() => {
        if (_editTabsVal?.length) {
            // processChange()
            loadf()

        }
    }, [_editTabsVal]);

    useEffect(() => {
        if (_zoomOcr) {
            zoomInPdfOcrView()
        }

    }, [_zoomOcr, _priorityFlag])


    /**@start Below useEffect is to restore xml tags on changing page**/
    useEffect(() => {
        if (_zoomOcr) {
            (async () => {
                setXmlTags([]);
                setCanvasContext()
                // if (pdf?.img)
                //     await decodeImg(pdf);
                // else
                //     await decodePdf(pdf);
                // enventRect();

            })()
        }


    }, [xmlMeta])

    /**end**/

    useEffect(() => {
        if (xmlMeta) {
            eveluateXML()
            _version(false)
        }

    }, [versionFlag]);

    // useEffect(()=>{
    //     loadf()
    //     },[_activeEditTabs])



    /**
     * @description function get xml file data and eveluate 
     */
    const eveluateXML = async () => {
        // console.log("hii", xmlMeta?.annotation?.object?.length, 11111111111)
        let xmlTagsEveluted = [];

        if (xmlMeta && !xmlMeta?.annotation?.object.length) {
            let value = xmlMeta?.annotation?.object;
            if(value !== undefined){
                xmlMeta.annotation.object = [];
                xmlMeta.annotation.object.push(value)
            }
        }
        let tempNewObject;
        for (var i = 0; i < xmlMeta?.annotation?.object?.length; i++) {

            if (is_multi_loan) {
                // console.log('xmlMeta?.annotation.object[i].bndbox',xmlMeta?.annotation.object[i].bndbox)


                if (xmin <= xmlMeta?.annotation?.object[i].bndbox.xmin._text && xmlMeta?.annotation?.object[i].bndbox.xmax._text <= xmax && y <= xmlMeta?.annotation?.object[i].bndbox.ymax._text) {



                    let newObj = {
                        id: `${xmlMeta?.annotation?.object[i]?.name._text}:${i}`, // this id use to maintain while fouse on any files hilight bounds on same index
                        updatedAt: xmlMeta?.annotation.object[i]?.updatedAt || false,
                        changesViaVersion: xmlMeta?.annotation.object[i]?.changesViaVersion || false,
                        tagId: `${i}:${pageNumber}`,
                        // tag: xmlMeta?.annotation?.object[i]?.name?._text,
                        tag: xmlMeta?.annotation?.object[i]?.updatedName?._text ? xmlMeta?.annotation.object[i].updatedName._text : xmlMeta?.annotation?.object[i]?.name?._text,
                        bounds: await eveluateXMLBounds(xmlMeta?.annotation?.object[i]?.bndbox)// evaluate height,width, xmin and ymin coordinates
                    }

                    // console.log('newObjnewObj',newObj)
                    let { intesr, flag } = await boundsIsOverlap(newObj);// compare overlap bounds with json 
                    // console.log(intesr, newObj, "checking intesr----------<<>>>><><><<><<><><><><><>")
                    let box_A = [newObj.bounds.xmin, newObj.bounds.ymin, newObj.bounds.xmax, newObj.bounds.ymax]

                    for (let subbLp = 0; subbLp < intesr.length; subbLp++) {
                        let box_B = [intesr[subbLp].xmin, intesr[subbLp].ymin, intesr[subbLp].xmax, intesr[subbLp].ymax]
                        let x_low = Math.max(box_A[0], box_B[0])
                        let y_low = Math.max(box_A[1], box_B[1])
                        let x_high = Math.min(box_A[2], box_B[2])
                        let y_high = Math.min(box_A[3], box_B[3])
                        let inter_area = Math.max(0, x_high - (x_low + 1)) * Math.max(0, y_high - y_low + 1)
                        let box_B_area = (box_B[2] - (box_B[0] + 1)) * (box_B[3] - (box_B[1] + 1))
                        let intersectedArea = inter_area / box_B_area
                        // console.log('newObj****', newObj)

                        intesr[subbLp].intersectedArea = intersectedArea
                        // console.log('In- ', newObj.tag, ' intersectedArea is- ', intersectedArea, ' for subtext- ', intesr[subbLp].text)


                    }

                    // intesr = intesr.filter((item) => item.intersectedArea >= 0.5)


                    //}
                    //break;

                    // intesr.splice(0, 1)
                    // console.log(intesr, "checkign intesr array----->>>>>>>>>>")

                    /***start, below condition is to remove single text having intersected area less than 0.5 */
                    for (let m = 0; m < intesr.length; m++) {

                        if (intesr[m].intersectedArea < 0.5) {
                            intesr.splice(m, 1);
                            m = m - 1
                        }

                    }
                    /**end of loop--------*******/

                    for (let k = 0; k < tempNewObject?.overlap?.length; k++) {

                        // if (tempNewObject?.overlap[k].text == "PORUTRANCE") {
                        //     let newInd = intesr.findIndex((item) => item.text === tempNewObject?.overlap[k].text)
                        //     console.log(tempNewObject?.overlap[k].text, tempNewObject, "chekcing temp objj-->")
                        // }
                        let newInd = intesr.findIndex((item) => item.text === tempNewObject?.overlap[k].text)

                        if (newInd > -1) {
                            // console.log("intersection point matched --->", tempNewObject.overlap[k].intersectedArea, intesr[newInd])
                            if (tempNewObject.overlap[k].intersectedArea < 0.5) {
                                tempNewObject.overlap.splice(k, 1)
                            }
                            if (intesr[newInd].intersectedArea < 0.5) {
                                intesr.splice(newInd, 1)
                            }
                        }
                    }

                    newObj.overlap = intesr;
                    let flag1 = true
                    // for (var z = 0; z < xmlTagsEveluted?.length; z++) {

                    //     let intersectdata = xmlTagsEveluted[z] && xmlTagsEveluted[z].overlap.filter(item => item.id === intesr[0]?.id);
                    //     if (intersectdata && intersectdata.length > 0) {
                    //         // console.log(z, '***zloopingi***',i)

                    //         // console.log(xmlTagsEveluted, 'xmlTagsEveluted', xmlTagsEveluted[z])
                    //         // console.log(intesr, '**intersectdata', intersectdata)
                    //         // console.log('***xmlMeta?.annotation.object[i]', xmlMeta?.annotation.object[i])
                    //         flag1 = false

                    //     }
                    // }
                    if (flag1) {

                        if (xmlTagsEveluted.length > 1) {
                            xmlTagsEveluted[xmlTagsEveluted.length - 1] = tempNewObject
                        }
                        xmlTagsEveluted.push(newObj);
                    }
                    // if (flag1 == false) {
                    //     // console.log('value is false', newObj)
                    //     // break;
                    // }
                    tempNewObject = newObj

                    // console.log('xmlTagsEveluted***==>', xmlTagsEveluted)
                    // if (!flag) {
                    //     xmlTagsEveluted.push(newObj);
                    // // }
                    // console.log(newObj, "newObj")

                }
            } else {

                let newObj = {
                    id: `${xmlMeta?.annotation?.object[i]?.name._text}:${i}`, // this id use to maintain while fouse on any files hilight bounds on same index
                    updatedAt: xmlMeta?.annotation.object[i]?.updatedAt || false,
                    changesViaVersion: xmlMeta?.annotation.object[i]?.changesViaVersion || false,
                    tagId: `${i}:${pageNumber}`,
                    // tag: xmlMeta?.annotation?.object[i]?.name?._text,
                    tag: xmlMeta?.annotation?.object[i]?.updatedName?._text ? xmlMeta?.annotation.object[i].updatedName._text : xmlMeta?.annotation?.object[i]?.name?._text,
                    bounds: await eveluateXMLBounds(xmlMeta?.annotation?.object[i]?.bndbox)// evaluate height,width, xmin and ymin coordinates
                }

                let { intesr, flag } = await boundsIsOverlap(newObj);// compare overlap bounds with json 
                // console.log(intesr, newObj, "checking intesr----------<<>>>><><><<><<><><><><><>")

                let box_A = [newObj.bounds.xmin, newObj.bounds.ymin, newObj.bounds.xmax, newObj.bounds.ymax]

                for (let subbLp = 0; subbLp < intesr.length; subbLp++) {
                    let box_B = [intesr[subbLp].xmin, intesr[subbLp].ymin, intesr[subbLp].xmax, intesr[subbLp].ymax]
                    let x_low = Math.max(box_A[0], box_B[0])
                    let y_low = Math.max(box_A[1], box_B[1])
                    let x_high = Math.min(box_A[2], box_B[2])
                    let y_high = Math.min(box_A[3], box_B[3])
                    let inter_area = Math.max(0, x_high - (x_low + 1)) * Math.max(0, y_high - y_low + 1)
                    let box_B_area = (box_B[2] - (box_B[0] + 1)) * (box_B[3] - (box_B[1] + 1))
                    let intersectedArea = inter_area / box_B_area
                    // console.log('newObj****', newObj)

                    intesr[subbLp].intersectedArea = intersectedArea
                    // console.log('In- ', newObj.tag, ' intersectedArea is- ', intersectedArea, ' for subtext- ', intesr[subbLp].text)


                }

                // intesr = intesr.filter((item) => item.intersectedArea >= 0.5)


                //}
                //break;

                // intesr.splice(0, 1)
                // console.log(intesr, "checkign intesr array----->>>>>>>>>>")


                /***start, below condition is to remove single text having intersected area less than 0.5 */
                for (let m = 0; m < intesr.length; m++) {

                    if (intesr[m].intersectedArea < 0.5) {
                        intesr.splice(m, 1);
                        m = m - 1
                    }

                }
                /**end of loop--------*******/

                for (let k = 0; k < tempNewObject?.overlap?.length; k++) {

                    // if (tempNewObject?.overlap[k].text == "PORUTRANCE") {
                    //     let newInd = intesr.findIndex((item) => item.text === tempNewObject?.overlap[k].text)
                    //     console.log(tempNewObject?.overlap[k].text, tempNewObject, "chekcing temp objj-->")
                    // }
                    let newInd = intesr.findIndex((item) => item.text === tempNewObject?.overlap[k].text)

                    if (newInd > -1) {
                        // console.log("intersection point matched --->", tempNewObject.overlap[k].intersectedArea, intesr[newInd])
                        if (tempNewObject.overlap[k].intersectedArea < 0.5) {
                            tempNewObject.overlap.splice(k, 1)
                        }
                        if (intesr[newInd].intersectedArea < 0.5) {
                            intesr.splice(newInd, 1)
                        }
                    }
                }

                newObj.overlap = intesr;
                let flag1 = true
                // for (var z = 0; z < xmlTagsEveluted?.length; z++) {
                //     let intersectdata = xmlTagsEveluted[z] && xmlTagsEveluted[z].overlap.filter(item => item.id === intesr[0]?.id);
                //     if (intersectdata && intersectdata.length > 0) {
                //         // console.log(z, '***zloopingi***',i)

                //         // console.log(xmlTagsEveluted, 'xmlTagsEveluted', xmlTagsEveluted[z])
                //         // console.log(intesr, '**intersectdata', intersectdata)
                //         // console.log('***xmlMeta?.annotation.object[i]', xmlMeta?.annotation.object[i])
                //         flag1 = false

                //     }
                // }
                if (flag1) {

                    if (xmlTagsEveluted.length > 1) {
                        xmlTagsEveluted[xmlTagsEveluted.length - 1] = tempNewObject
                    }

                    xmlTagsEveluted.push(newObj);
                }
                // if (flag1 == false) {
                //     // console.log('value is false', newObj)
                //     // break;
                // }
                tempNewObject = newObj

                // console.log('xmlTagsEveluted***==>', xmlTagsEveluted)
                // if (!flag) {
                //     xmlTagsEveluted.push(newObj);
                // // }
                // console.log(newObj, "newObj")

            }
        }

        /**  @start removing duplicate json from overlap-------------------*/
        // console.log(xmlTagsEveluted, "checking xmlTagEveluted---")
        let prevArray;
        for (let i = 0; i < xmlTagsEveluted.length - 1; i++) {
            prevArray = xmlTagsEveluted[i].overlap

            for (let j = i + 1; j < xmlTagsEveluted.length; j++) {
                let currentArray = xmlTagsEveluted[j].overlap
                for (let k = 0; k < prevArray.length; k++) {

                    let newInd = currentArray.findIndex((item) => item.text === prevArray[k].text && item.x == prevArray[k].x && item.y == prevArray[k].y)

                    if (newInd > -1) {

                        // prevArray.splice(k, 1)
                        xmlTagsEveluted[j].overlap.splice(newInd, 1)


                    }
                }
            }
        }

        // console.log('xmlTagsEveluted', scale, ocrScale, xmlTagsEveluted)

        /* @end------------- */
        /** @setTimeout logic----   in the below code , setTimeOut is used to set _xmlTags only after executing all the functionality like
         * removing duplicate json text, remove json text which is having intersection area less than 0.5**/
        // setTimeout(() => {
        if (scale == idleScale) {
            _xmlTags(prevState => prevState = JSON.parse(JSON.stringify([...xmlTagsEveluted])));
            _xmlTagsOriginal(prevState => prevState = JSON.parse(JSON.stringify([...xmlTagsEveluted])))
        }
        // }, 200)
        //    _xmlTags(prevState => prevState = [...xmlTagsEveluted]);
        setXmlTags(prevState => prevState = [...xmlTagsEveluted]);







    }




    /**
     * @description method call to set bounds with scale for XML eveluate 
     * @param {*} bouns rectange 
     * @returns 
     */
    const eveluateXMLBounds = async (bouns) => {
        // console.log(bouns, "cheking 000000000 bouns in ocr view------->>>>>>>>")
        // console.log(bouns, "cheking 000000000 bouns in ocr view------->>>>>>>>")
        // console.log(scaleCal(bouns?.xmin?._text), bouns.xmin._text, "cheking 0002223344441444========000000 bouns in ocr view------->>>>>>>>")
        let bounds = {
            x: scaleCal(bouns?.xmin?._text),
            //  y: scaleCal(bouns.ymin._text),
            y: scaleCalHeight(bouns?.ymin?._text),
            w: (scaleCal(bouns?.xmax?._text) - scaleCal(bouns?.xmin?._text)),
            //  h: (scaleCal(bouns.ymax._text) - scaleCal(bouns.ymin._text))
            h: (scaleCalHeight(bouns?.ymax?._text) - scaleCalHeight(bouns?.ymin?._text)),
            xmin: scaleCal(bouns?.xmin?._text),
            xmax: scaleCal(bouns?.xmax?._text),
            ymin: scaleCalHeight(bouns?.ymin?._text),
            ymax: scaleCalHeight(bouns?.ymax?._text)
        }
        // console.log(bounds, "checking bounds in ocr-view--------->>>>>")
        // console.log(bounds, "checking 1111111111 bounds in ocr view----->>>>>>>>")
        return bounds
    }

    /**
     * @description method call to disply tooltip 
     * @param {*} value  text which need to display in tooltip
     * @param {*} mouse current mouse event     
     */
    const toolTipDraw = (value, mouse,) => {
        tipCanvas.style.display = "block";
        tipCanvas.style.pointerEvents = "none";
        let tagTxt = 'Tag Name:'
        tipCanvas.width = tipCtx.measureText(tagTxt).width + tipCtx.measureText(value).width + 10;
        let left;
        // console.log('sadasdd', mouse.clientX, tipCanvas.width)
        if ((mouse.clientX - tipCanvas.width - 340 - 40) > 0) {
            left = (mouse.clientX - tipCanvas.width - 340 - 40)
        } else {
            left = mouse.clientX - 340 + 40
        }
        tipCanvas.style.left = left + "px";
        tipCanvas.style.top = (mouse.clientY - 103) + "px";
        tipCtx.fillStyle = 'white'
        tipCtx.clearRect(0, 0, tipCanvas.width, tipCanvas.height);
        tipCtx.fillText(`${tagTxt}`, 5, 15);
        tipCtx.fillText(`${capitalizeFirstLetter(value)}`, 55, 15);
    }




    /**
     * @description function use for show toltip  on mousehover
     */
    const enventRect = () => {
        if (canvas !== null) {  // Check if the element with id for canvas exists
            canvas.onmousemove = (e) => {
                var cvsoffset = canvas.getBoundingClientRect();
                let mouseX = parseInt(e.clientX - cvsoffset.x);
                let mouseY = parseInt(e.clientY - cvsoffset.y);
                let hits = false
                xmlTags.forEach((item) => {
                    if (hit(item.bounds, mouseX, mouseY, scale)) { // check current mouse cursor position and show tooltip on pdf
                        toolTipDraw(item.tag, e)
                        hits = true
                    }
                    if (!hits)
                        tipCanvas.style.display = "none";
                })
            }
            let isProcessing = false
            canvas.onclick = async (e) => {
                // console.log(canvasContext);
                if(isProcessing){
                    console.log("Still processing the previous click. Please wait...");
                    return;
                }
                isProcessing = true;
                try {
                    if(canvasContext !== undefined)
                    canvasContext.clearRect(0, 0, 700, 500);
                    // canvasContext.beginPath();
                    if (pdf?.img) {
                        await decodeImg(pdf);
                    } else {
                        await decodePdf(pdf);
                    }
                    var cvsoffset = canvas.getBoundingClientRect();
                    var mouseX = parseInt(e.clientX - cvsoffset.x);
                    var mouseY = parseInt(e.clientY - cvsoffset.y);

                    if (_activeEditTabs && _activeEditTabs === '2') {
                        let flag = false;
                        let rectObj = null
                        xmlTags.forEach(async (rect, inx) => {
                            let tagClicked = false;

                            if (rect.bounds && hit(rect.bounds, mouseX, mouseY, scale)) {
                                tagClicked = true;
                                flag = true;
                                rectObj = rect;
                                //  _uniId(rect,true)
                            } else {
                                flag = false
                                // _uniId(null,false)
                            }

                            if (tagClicked === true) {
                                _setScrollOnSelect({ x: rect.bounds.x / 2, y: rect.bounds.y / 2 }); // focus and scroll
                            }
                            onOcrClick()
                            resetXMLBounds(rect, tagClicked === true ? '#DE3163' : '#0000FF', tagClicked === true ? true : false) // call function to draw xml solid boundaries on pdf/png/jpg
                        })

                        _uniId(rectObj, flag)
                    } else {
                        xmlTags.forEach((item, inx) => {
                            item.overlap.forEach((jsItm) => {
                                if (jsItm && hit(jsItm, mouseX, mouseY, scale)) { // check current mouse cursor position and show tooltip on pdf
                                    resetJsonBounds(jsItm, true)
                                    _uniId(jsItm, true)
                                } else {
                                    resetJsonBounds(jsItm)
                                    onOcrClick()
                                    _uniId(null, false)
                                }

                            })
                        })
                    }
                    if (is_multi_loan) {
                        multiLoanBoundaries();
                    }
                } catch (error) {
                    console.error("Error during PDF decoding or image processing:", error);
                } finally {
                    isProcessing = false; 
                }

            }
        }
        // setTimeout(() => {
        //     if (ocrCanvasClick.current) {
        //         ocrCanvasClick.current.click();
        //     }
        // }, 3000);

    }
    /**
     * @description method call for drow boundary with soild boarder 
     * @param {*} rect  rectange 
     */
    const resetXMLBounds = (rect, color = "#0000FF", flg) => {
        canvasContext.strokeStyle = color
        if (rect?.updatedAt) { // heilight edited bounds
            canvasContext.strokeStyle = "#ff0000";
            canvasContext.lineWidth = 1;
        }
        canvasContext.setLineDash([]);
        if (flg)
            canvasContext.lineWidth = 3;
        else
            canvasContext.lineWidth = 1;
        canvasContext.strokeRect(rect.bounds.x,
            rect.bounds.y,
            rect.bounds.w,
            rect.bounds.h,
        );
    }

    const zoomInPdfOcrView = async () => {
        console.log('canvas conText in ocr page (zoom)', canvasContext)
        if (canvasContext != undefined) {

            if (_activeTab == 1) {
                canvasContext.clearRect(0, 0, 700, 500);
                // console.log("canvasContext",canvasContext);
                setCanvasContext();
                setOcrScale();
                setXmlTags([]);
                if (pdf?.img)
                    await decodeImg(pdf);
                else
                    await decodePdf(pdf);
                enventRect();
            }
        }
        // setTimeout(() => {
        //     if (ocrCanvasClick.current) {
        //         ocrCanvasClick.current.click();
        //         // setClickedOnce(true);
        //     }
        // }, 3000);

    }

    // const [clickedOnce, setClickedOnce] = useState(false)

    // /**
    //  * @description function re initalization on refreash/any actions
    //  */
    const loadf = async () => {
        if (pdf?.img)
            await decodeImg(pdf);
        else
            await decodePdf(pdf);
        await drawTagsBounds()
        enventRect()
        // setTimeout(() => {
        //     if (ocrCanvasClick.current) {
        //         ocrCanvasClick.current.click();
        //         // setClickedOnce(true);
        //     }
        // }, 3000);

    }



    /**
     * @description method call for drow boundary with dotted lines
     * @param {*} rect  rectange
     */
    const resetJsonBounds = (rect, hilighitFlg = false) => {
        if (canvasContext) {
            canvasContext.strokeStyle = getBoundsColour(rect.confidence, cYellowRange, cRedRange)
            if (!hilighitFlg) {
                canvasContext.setLineDash([2]);
                if (getBoundsColour(rect.confidence, cYellowRange, cRedRange) == "red") {
                    canvasContext.lineWidth = 2.5;
                }
                else {
                    canvasContext.lineWidth = 1;
                }

                if (rect?.updatedAt) { // heilight edited bounds
                    canvasContext.strokeStyle = "#0000FF";
                    canvasContext.setLineDash([]);
                }
            }
            else {
                canvasContext.strokeStyle = "#DE3163"; // hilight on focus
                canvasContext.lineWidth = 3;
                canvasContext.setLineDash([]); // make solid boundries
                if (isRightClicked) {
                    _setScrollOnSelect({ x: rect.x / 1.4, y: rect.y / 1.2 });
                }

            }
            /**
            *@start below code is commented to handle "review requested" click issue
             */

            // canvasContext.strokeRect(rect.x, rect.y, rect.w, rect.h)

            /**
             @end
             * */

            /**
             * @start below code is used to dispable green tags on review request click
             * */
            if (_fieldPriority == 2 && rect.confidence < 0.9) {
                canvasContext.strokeRect(rect.x, rect.y, rect.w, rect.h)
            }
            else if (_fieldPriority != 2 && rect.confidence >= 0.9) {
                canvasContext.strokeRect(rect.x, rect.y, rect.w, rect.h)
            }
            else if (_fieldPriority == false) {
                canvasContext.strokeRect(rect.x, rect.y, rect.w, rect.h)
            }

            /**
             @end
             * */


        }
    }



    /**
    * @description method call for drow boundary with dotted lines
    * @param {*} rect  rectange
    */
    const multiLoanBoundaries = (rect, hilighitFlg = false) => {

        // console.log('aaaaaaaa->')
        if (canvasContext) {
            // console.log('aaaaaaab->',xmin,xmax,height)

            canvasContext.strokeStyle = "grey";
            canvasContext.lineWidth = 2.5;
            canvasContext.strokeRect(scaleJsonCal(xmin - 10), scaleJsonCal(y), scaleJsonCal(xmax - xmin), height)



        }
    }

    /**
     * @description func for calculateing scale
     * @param {*} itam coordinates
     * @returns number
     */
    const scaleCal = (item) => (Number(item) / Number(ocrScale))

    const scaleCalHeight = (item) => (Number(item) / Number(ocrScaleHeight))

    /**
     * @description func for calculateing scale
     * @param {*} itam coordinates
     * @returns number
     */
    const scaleJsonCal = (item) => (Number(item) / Number(ocrJsonScale))
    const scaleJsonCalHeight = (item) => (Number(item) / Number(ocrJsonScaleHeight))

    /**
     * @description Function calculating bounds height and width
     * @param {Number} value accepting number value
     * @returns return number value
     */
    const calc = (value) => (value < 0 ? value * -1 : value);


    /**
      * @description function draw bounderies on pdf from XML data
      * @param {*} canvasContext canvas content instance
      */
    const drawTagsBounds = async () => {
        // console.log(xmlTags, "checking xml tags inn drawtag--------->>>>><>>>")
        xmlTags.map(async (rect, inx) => {
            if (_activeEditTabs && _activeEditTabs === '2') {
                if (_editTag == inx) {
                    _setScrollOnSelect({ x: rect.bounds.x / 2, y: rect.bounds.y / 2 }); // focus and scroll
                }
                resetXMLBounds(rect, _editTag == inx ? '#DE3163' : '#0000FF', _editTag === inx ? true : false) // call function to draw xml solid boundaries on pdf/png/jpg 
            } else {

                rect.overlap.forEach((item) => {
                    // console.log('item----->',item) // commenting out extra consoles

                    // drow json bounds on pdf/png/jpg
                    if (_fieldPriority == 2 && item.confidence < 0.9) // _fieldPriority flag ti identify which field's should be display red/yellow
                        resetJsonBounds(item, item.id === _editTabsVal ? true : false)
                    else if (_fieldPriority == 1 && item.confidence > 0.9) // _fieldPriority flag ti identify which field's should be display red/yellow
                        resetJsonBounds(item, item.id === _editTabsVal ? true : false)
                    else if (!_fieldPriority)
                        resetJsonBounds(item, item.id === _editTabsVal ? true : false)
                })
            }
        })

        if (is_multi_loan) {
            multiLoanBoundaries();
        }
    };

    /**
     * @description function call to check overlapping rectange json bounds 
     * @param {*} xmlTg XML bounds data
     * @returns retun array which is overlapping
     */
    const boundsIsOverlap_v1 = async (xmlTg) => {
        let intesr = [];
        let flag = false;
        for (var j = 0; j < jsonMetaData.analyzeResult.readResults[0].lines.length; j++) {
            var words = jsonMetaData.analyzeResult.readResults[0].lines[j].words;
            for (var i = 0; i < words.length; i++) {

                var word = words[i];
                let xco = {
                    x: scaleJsonCal(word.boundingBox[0]), // scaleJsonCal function use to set zoom in/out coordinates
                    y: scaleJsonCal(word.boundingBox[1]),
                    w: (calc(scaleJsonCal(word.boundingBox[2]) - scaleJsonCal(word.boundingBox[0]))),
                    h: (calc(scaleJsonCal(word.boundingBox[1]) - scaleJsonCal(word.boundingBox[7]))),
                    text: word.text,
                    isAccepted: word.isAccepted,
                    acceptedAt: word.acceptedAt,
                    confidence: word.confidence,
                    updatedAt: word?.updatedAt || false // set if any tags/text values updating to maintain logs

                }
                if (intersectRect(xmlTg.bounds, xco)) { //identify intesect rectange xml/ json
                    if (xmlTg.tag.indexOf('aggregator_logo') != -1) {

                        if (xco.confidence >= confidence?.start_range && xco.confidence <= confidence?.end_range) {
                            xco = { ...xco, id: `${word.boundingBox[0]}:${word.boundingBox[1]}` }
                            intesr.push(xco);
                            break;

                        }
                    } else {
                        xco = { ...xco, id: `${word.boundingBox[0]}:${word.boundingBox[1]}` }
                        intesr.push(xco)

                    }
                }

            }
            if (flag)
                break;


        }
        return { intesr, flag }

    }




    // const boundsIsOverlap = async (xmlTg) => {
    //     //console.log(ocrJsonScale, 'boundsIsOverlap json scale values', ocrJsonScaleHeight)
    //     let intesr = [];
    //     let flag = false;
    //     for (var i = 0; i < jsonMetaData?.text.length; i++) {
    //         let xco = {
    //             x: scaleJsonCal(jsonMetaData.left[i]), // scaleJsonCal function use to set zoom in/out coordinates
    //             y: scaleJsonCalHeight(jsonMetaData.top[i]),
    //             //  y: scaleJsonCal(jsonMetaData.top[i]),
    //             w: scaleJsonCal(jsonMetaData.width[i]),
    //             h: scaleJsonCalHeight(jsonMetaData.height[i]),
    //             /*xmax: scaleJsonCal(jsonMetaData.left[i]),
    //             xmin: jsonMetaData.left[i] > jsonMetaData.width[i] ? scaleJsonCal(jsonMetaData.left[i])-scaleJsonCal(jsonMetaData.width[i]) : scaleJsonCal(jsonMetaData.width[i]) - scaleJsonCal(jsonMetaData.left[i]),
    //             ymax:scaleJsonCalHeight(jsonMetaData.top[i]),
    //             ymin:jsonMetaData.top[i] > jsonMetaData.height[i] ? scaleJsonCalHeight(jsonMetaData.top[i])-scaleJsonCalHeight(jsonMetaData.height[i]) : scaleJsonCalHeight(jsonMetaData.height[i]) - scaleJsonCalHeight(jsonMetaData.top[i]),*/

    //             /* given xmin is starting point and x max is the width-17Jan-22*/
    //             xmin: scaleJsonCal(jsonMetaData.left[i]),
    //             xmax: + scaleJsonCal(jsonMetaData.left[i]) + scaleJsonCal(jsonMetaData.width[i]),
    //             ymin: scaleJsonCalHeight(jsonMetaData.top[i]),
    //             ymax: + scaleJsonCalHeight(jsonMetaData.top[i]) + scaleJsonCalHeight(jsonMetaData.height[i]),


    //             // h: scaleJsonCal(jsonMetaData.height[i]),
    //             text: jsonMetaData.text[i],
    //             confidence: jsonMetaData.confidence[i],
    //             updatedAt: jsonMetaData?.updatedAt && jsonMetaData?.updatedAt[jsonMetaData.left[i] + '-' + jsonMetaData.top[i]] ? jsonMetaData?.updatedAt[jsonMetaData.left[i] + '-' + jsonMetaData.top[i]] : false, // set if any tags/text values updating to maintain logs
    //             isAccepted: jsonMetaData?.isAccepted && jsonMetaData?.isAccepted[jsonMetaData.left[i] + '-' + jsonMetaData.top[i]] ? true : false,
    //             isDraft: jsonMetaData?.isDraft && jsonMetaData?.isDraft[jsonMetaData.left[i] + '-' + jsonMetaData.top[i]] ? true : false,
    //             updatedAt: jsonMetaData?.updatedAt && jsonMetaData?.updatedAt[jsonMetaData.left[i] + '-' + jsonMetaData.top[i]] ? jsonMetaData?.updatedAt[jsonMetaData.left[i] + '-' + jsonMetaData.top[i]] : false,
    //             draftText: jsonMetaData?.draftText && jsonMetaData?.draftText[jsonMetaData.left[i] + '-' + jsonMetaData.top[i]] ? jsonMetaData?.draftText[jsonMetaData.left[i] + '-' + jsonMetaData.top[i]] : false,

    //             changesViaVersion: jsonMetaData?.changesViaVersion && jsonMetaData?.changesViaVersion[jsonMetaData.left[i] + '-' + jsonMetaData.top[i]] ? jsonMetaData?.changesViaVersion[jsonMetaData.left[i] + '-' + jsonMetaData.top[i]] : '',

    //         }

    //         //console.log(ocrJsonScale, 'boundsIsOverlap json xco values', xco)

    //         if (xco.confidence && intersectRect(xmlTg.bounds, xco)) { //identify intesect rectange xml/ json
    //             if (xmlTg.tag.indexOf('aggregator_logo') != -1) {

    //                 if (xco.confidence >= confidence?.start_range && xco.confidence <= confidence?.end_range) {
    //                     xco = { ...xco, id: `${jsonMetaData.left[i]}-${jsonMetaData.top[i]}`, pageId: `${jsonMetaData.left[i]}-${jsonMetaData.top[i]}-${pageNumber}` }


    //                     intesr.push(xco);
    //                     break;

    //                 }
    //             } else {
    //                 xco = { ...xco, id: `${jsonMetaData.left[i]}-${jsonMetaData.top[i]}`, pageId: `${jsonMetaData.left[i]}-${jsonMetaData.top[i]}-${pageNumber}` }
    //                 intesr.push(xco)

    //             }

    //         }


    //     }
    //     console.log('==> intesr ==>', intesr)

    //     return { intesr, flag }

    // }
    const boundsIsOverlap = async (xmlTg) => {
        //console.log(ocrJsonScale, 'boundsIsOverlap json scale values', ocrJsonScaleHeight)
        let intesr = [];
        let flag = false;
        for (var i = 0; i < jsonMetaData?.text.length; i++) {
            let xco = {
                x: scaleJsonCal(jsonMetaData.left[i]), // scaleJsonCal function use to set zoom in/out coordinates
                y: scaleJsonCalHeight(jsonMetaData.top[i]),
                //  y: scaleJsonCal(jsonMetaData.top[i]),
                w: scaleJsonCal(jsonMetaData.width[i]),
                h: scaleJsonCalHeight(jsonMetaData.height[i]),

                /*xmax: scaleJsonCal(jsonMetaData.left[i]),
                xmin: jsonMetaData.left[i] > jsonMetaData.width[i] ? scaleJsonCal(jsonMetaData.left[i])-scaleJsonCal(jsonMetaData.width[i]) : scaleJsonCal(jsonMetaData.width[i]) - scaleJsonCal(jsonMetaData.left[i]),
                ymax:scaleJsonCalHeight(jsonMetaData.top[i]),
                ymin:jsonMetaData.top[i] > jsonMetaData.height[i] ? scaleJsonCalHeight(jsonMetaData.top[i])-scaleJsonCalHeight(jsonMetaData.height[i]) : scaleJsonCalHeight(jsonMetaData.height[i]) - scaleJsonCalHeight(jsonMetaData.top[i]),*/

                /* given xmin is starting point and x max is the width-17Jan-22*/
                xmin: scaleJsonCal(jsonMetaData.left[i]),
                xmax: + scaleJsonCal(jsonMetaData.left[i]) + scaleJsonCal(jsonMetaData.width[i]),
                ymin: scaleJsonCalHeight(jsonMetaData.top[i]),
                ymax: + scaleJsonCalHeight(jsonMetaData.top[i]) + scaleJsonCalHeight(jsonMetaData.height[i]),


                // h: scaleJsonCal(jsonMetaData.height[i]),
                text: jsonMetaData.text[i],
                originalText: jsonMetaData.text[i],
                confidence: jsonMetaData.confidence[i],
                // NOTE : earlier we were saving id by concating left and top xml values by a '-' but now we are saving them as ':', so both conditions are checked for matching both old and new docs.
                updatedAt: jsonMetaData?.updatedAt && (jsonMetaData?.updatedAt[jsonMetaData.left[i] + ':' + jsonMetaData.top[i]] || jsonMetaData?.updatedAt[jsonMetaData.left[i] + '-' + jsonMetaData.top[i]])? (jsonMetaData?.updatedAt[jsonMetaData.left[i] + ':' + jsonMetaData.top[i]] || jsonMetaData?.updatedAt[jsonMetaData.left[i] + '-' + jsonMetaData.top[i]]) : false, // set if any tags/text values updating to maintain logs
                isAccepted: jsonMetaData?.isAccepted && (jsonMetaData?.isAccepted[jsonMetaData.left[i] + ':' + jsonMetaData.top[i]] || jsonMetaData?.isAccepted[jsonMetaData.left[i] + '-' + jsonMetaData.top[i]]) ? true : false,
                // updatedAtt: jsonMetaData?.updatedAt && jsonMetaData?.updatedAt[jsonMetaData.left[i] + '-' + jsonMetaData.top[i]] ? jsonMetaData?.updatedAt[jsonMetaData.left[i] + ':' + jsonMetaData.top[i]] : false,
                changesViaVersion: jsonMetaData?.changesViaVersion && (jsonMetaData?.changesViaVersion[jsonMetaData.left[i] + ':' + jsonMetaData.top[i]] || jsonMetaData?.changesViaVersion[jsonMetaData.left[i] + '-' + jsonMetaData.top[i]]) ? (jsonMetaData?.changesViaVersion[jsonMetaData.left[i] + ':' + jsonMetaData.top[i]] || jsonMetaData?.changesViaVersion[jsonMetaData.left[i] + '-' + jsonMetaData.top[i]]) : '',

            }


            //console.log(ocrJsonScale, 'boundsIsOverlap json xco values', xco)

            if (xco.confidence && intersectRect(xmlTg.bounds, xco)) { //identify intesect rectange xml/ json

                if (xmlTg.tag.indexOf('aggregator_logo') != -1) {

                    if (xco.confidence >= confidence?.start_range && xco.confidence <= confidence?.end_range) {
                        xco = { ...xco, id: `${jsonMetaData.left[i]}:${jsonMetaData.top[i]}`, pageId: `${jsonMetaData.left[i]}:${jsonMetaData.top[i]}:${pageNumber}` }


                        intesr.push(xco);
                        break;

                    }
                } else {
                    xco = { ...xco, id: `${jsonMetaData.left[i]}:${jsonMetaData.top[i]}`, pageId: `${jsonMetaData.left[i]}:${jsonMetaData.top[i]}:${pageNumber}` }

                    intesr.push(xco)

                }

            }


        }

        // console.log('==> intesr ==>', intesr)

        return { intesr, flag }

    }

    const boundsIsOverlap_back_up = async (xmlTg) => {
        let intesr = [];
        let flag = false;
        jsonMetaData.analyzeResult.readResults[0].lines.map((val) =>
            val.words.map(async (word) => {
                let xco = {
                    x: scaleJsonCal(word.boundingBox[0]), // scaleJsonCal function use to set zoom in/out coordinates
                    y: scaleJsonCal(word.boundingBox[1]),
                    w: (calc(scaleJsonCal(word.boundingBox[2]) - scaleJsonCal(word.boundingBox[0]))),
                    h: (calc(scaleJsonCal(word.boundingBox[1]) - scaleJsonCal(word.boundingBox[7]))),
                    text: word.text,
                    isAccepted: word.isAccepted,
                    acceptedAt: word.acceptedAt,
                    confidence: word.confidence,
                    updatedAt: word?.updatedAt || false // set if any tags/text values updating to maintain logs
                }
                if (intersectRect(xmlTg.bounds, xco)) { //identify intesect rectange xml/ json



                    if (xmlTg.tag.indexOf('aggregator_logo') != -1) {
                        if (xco.confidence >= confidence?.start_range && xco.confidence <= confidence?.end_range) {

                            xco = { ...xco, id: `${word.boundingBox[0]}-${word.boundingBox[1]}` }
                            intesr.push(xco);

                        } else {

                            flag = true;

                        }
                    } else {
                        xco = { ...xco, id: `${word.boundingBox[0]}-${word.boundingBox[1]}` }
                        intesr.push(xco)

                    }
                }



            })
        )
        return { intesr, flag }

    }


    /**
  * @description Function getting canvas context
  * @param {Number} value accepting width and height
  * @returns return canvas context
  */
    const create2dContext = (width, height) => {
        let canvas = document.getElementById("ocr-canvas");
        if (canvas !== null) { // Check if the element with id for canvas exists
            let tipCanvas = document.getElementById("tip");
            let tipCtx = tipCanvas.getContext("2d");
            setCanvas(canvas)
            setTipCanvas(tipCanvas)
            setTipCtx(tipCtx)
            canvas.width = width;
            canvas.height = height;
            return canvas.getContext("2d");
        }
    };

    const [isRendering, setIsRendering] = useState(false);
    /**
     * @description Function to render PDF data over canvas
     * @returns return updated canvas
     */
    const decodePdf = async (pdf) => {

        if(isRendering){
            console.log("Still processing the rendering. Please wait...");
            return;
        }
        setIsRendering(true);
        // console.log(canvaRender, "checking canvaRender in decode pdf---====>>>>")
        // if (canvaRender) {

        let page = await pdf.getPage(parseInt(pageNumber));
        // console.log(page, "checking viewport on decodepdf")
        let currentPdfWidth = await page.getViewport({ scale: scale }).width;
        let currentPdfHeight = await page.getViewport({ scale: scale }).height;
        let viewport = await page.getViewport({ scale: scale });
        const { width, height } = viewport;
        setHeight(height);
        let canvasContext = await create2dContext(width, height);
        try {
            await page.render({ canvasContext, viewport }).promise;
        } catch (error) {
            console.error('Page rendering error:', error);
        } finally {
            setIsRendering(false); // Re-enable after rendering is complete
        }
        // setOcrJsonScale(jsonMetaData?.analyzeResult?.readResults[0]?.width / currentPdfWidth)

        // console.log(currentPdfWidth, 'currentPdfWidth pdf currentPdfHeight', currentPdfHeight)
        // console.log(jsonMetaData?.page_width, '**decodePdf jsonMetaData**', jsonMetaData?.page_height)
        // console.log('decodePdf xmlMeta', xmlMeta?.annotation.size)

        setOcrJsonScale(jsonMetaData?.page_width / currentPdfWidth)
        setOcrJsonScaleHeight(jsonMetaData?.page_height / currentPdfHeight)
            if(xmlMeta?.annotation){
            setOcrScale(xmlMeta?.annotation.size.width._text / currentPdfWidth)
            setOcrScaleHeight(xmlMeta?.annotation.size.height._text / currentPdfHeight)
        }

        setCanvasContext(canvasContext);
        setCanvasContextFlag(true)
        _setLoader(true);
        _zoomFlag(false);
        // console.log(jsonMetaData?.page_width / currentPdfWidth, '--jsoncalculationsxml width---', xmlMeta?.annotation.size.width._text / currentPdfWidth)

        // console.log(jsonMetaData?.page_height / currentPdfHeight, '--jsoncalculationsxml height---', xmlMeta?.annotation.size.height._text / currentPdfHeight)
        // console.log("canvasContext",canvasContext)

        // }

            // if (ocrCanvasClick.current && !clickedOnce) {
            //     ocrCanvasClick.current.click();
            //     setClickedOnce(true);
            // }

    };

    /**
 * @description Function to render Image data over canvas
 * @returns return updated canvas
 */
    const decodeImg = async (imgInst) => {

        const { width, height } = imgInst;

        setHeight(height);
        //  const width = imgInst.img.naturalWidth;
        //   const height = imgInst.img.naturalHeight;
        let canvasContext = await create2dContext(width * scale, height * scale);
        console.log('canvas context of ocr page -->', canvasContext)
        canvasContext.drawImage(imgInst.img, 0, 0, width * scale, height * scale);

        // setOcrJsonScale(jsonMetaData?.analyzeResult?.readResults[0]?.width / (width * scale))
        setOcrJsonScale(jsonMetaData?.page_width / (width * scale))
        setOcrJsonScaleHeight(jsonMetaData?.page_height / (height * scale))
        if(xmlMeta){
            if (Object.keys(xmlMeta).length) {  // change for no xml response doc
                setOcrScale(xmlMeta.annotation.size.width._text / (width * scale))
                setOcrScaleHeight(xmlMeta.annotation.size.height._text / (height * scale))
            }
        }
        
        setCanvasContext(canvasContext);
        _setLoader(true);
        _zoomFlag(false);




    }

    return (
        <>
            {/* {console.log(_activeEditTabs, "checkindg _activeEditTabs in ocr")} */}
            {/* {console.log(_zoomOcr, "sss This is _zoom ocr in ocr view")} */}
            <canvas id="tip" data-placement="auto top" ref={canvasRef} width="300" height="25"></canvas> <canvas id="ocr-canvas"></canvas>
            {(pdfPagesCount > 1 && !is_multi_loan) && <>
            <div id="prevBtn"
             class="prevBtn" 
             onClick={() => prevPage(Number(pageNumber) - 1)} 
             style={{ 
                position: "fixed", 
                top: '60%', 
                left: 360, 
                background: "lightgrey", 
                padding: 8, 
                borderRadius: 4, 
                pointerEvents: pageNumber == 1 && "none",
                cursor: pageNumber !== 1 && "pointer",
                opacity: pageNumber == 1 && 0.5
                }}>
            </div>
            <div class="nextBtn" 
                id="nextBtn" 
                onClick={() => nextPage(Number(pageNumber) + 1)} 
                style={{ 
                    position: "fixed", 
                    top: '60%', 
                    right: 290, 
                    background: "lightgrey", 
                    padding: 8, 
                    borderRadius: 4, 
                    pointerEvents: pageNumber == pdfPagesCount && "none",
                    cursor: pageNumber !== pdfPagesCount && "pointer",
                    opacity: pageNumber == pdfPagesCount && 0.5
                    }}>
                </div>
            </>}
        </> 
    );
};
export default OcrView;
